import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, Box } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Handle scroll to top
  const handleScrollToTop = () => {
    // Try multiple methods to ensure compatibility across browsers
    try {
      // Method 1: Modern smooth scrolling
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } catch (error) {
      // Method 2: Fallback to traditional scrolling
      window.document.body.scrollTop = 0; // For Safari
      window.document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 40,
        right: 40,
        zIndex: 9999,
      }}
    >
      <Fab
        color="primary"
        size="large"
        aria-label="Back to top"
        onClick={handleScrollToTop}
        sx={{
          boxShadow: '0 8px 16px rgba(58, 54, 224, 0.35)',
          background: 'linear-gradient(45deg, #3a36e0 30%, #6e6ff7 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #2a26b9 30%, #5a5be6 90%)',
            transform: 'scale(1.05)',
            boxShadow: '0 10px 20px rgba(58, 54, 224, 0.45)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <KeyboardArrowUp fontSize="large" />
      </Fab>
    </Box>
  );
};

export default ScrollToTop; 